module.exports = __webpack_public_path__ + "72fcdff6b347a9bea837f493b4bc58a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/category_icons/ic_phonereload.png
// module id = 951
// module chunks = 0